/* eslint-disable camelcase */
import PropTypes from "prop-types";

export const backgroundSizeProp = PropTypes.oneOf(["cover", "contain", "stretch"]);

export const mediaQueryProp = PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.object)]);

export const imageProp = PropTypes.shape({
    backgroundPosition: PropTypes.string,
    backgroundSize: backgroundSizeProp,
    title: PropTypes.string,
    type: PropTypes.string,
    url: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    mediaQuery: mediaQueryProp,
    meta: PropTypes.shape({
        name: PropTypes.string,
    }),
});

export const cmsImageProp = PropTypes.shape({
    alt: PropTypes.string,
    caption: PropTypes.string,
    description: PropTypes.string,
    meta: PropTypes.shape({
        name: PropTypes.string,
    }),
    title: PropTypes.string,
    url: PropTypes.string,
});

export const videoProp = PropTypes.shape({
    title: PropTypes.string,
    type: PropTypes.string,
    url: PropTypes.string,
});

export const backgroundFlexibleProp = PropTypes.oneOfType([
    PropTypes.string,
    imageProp,
    videoProp,
    PropTypes.exact({
        desktop: PropTypes.oneOfType([PropTypes.string, imageProp, videoProp]),
        mobile: PropTypes.oneOfType([PropTypes.string, imageProp, videoProp]),
    }),
]);

export const backgroundTypeProp = PropTypes.oneOf(["image", "video", "color", "none"]);

const videoPlayerSettings = PropTypes.exact({
    autoplay: PropTypes.bool,
    controls: PropTypes.bool,
    loop: PropTypes.bool,
    muted: PropTypes.bool,
    poster: PropTypes.exact({
        meta: PropTypes.object,
        title: PropTypes.string,
        url: PropTypes.string,
    }),
});

export const videoPlayerProp = PropTypes.exact({
    desktop: PropTypes.exact({
        settings: videoPlayerSettings,
        video: videoProp,
    }),
    mobile: PropTypes.exact({
        settings: videoPlayerSettings,
        video: videoProp,
    }),
});
